import { render, staticRenderFns } from "./ReleaseUpdateNotice.vue?vue&type=template&id=87fc90e8&scoped=true&"
import script from "./ReleaseUpdateNotice.vue?vue&type=script&lang=js&"
export * from "./ReleaseUpdateNotice.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseUpdateNotice.vue?vue&type=style&index=0&id=87fc90e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fc90e8",
  null
  
)

export default component.exports